var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"chaton-userbar_loader chaton-inner-loaader"},[_c('span',[_c('i',{staticClass:"chaton-spinericon"})])])}]

export { render, staticRenderFns }